var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav-tabs',{attrs:{"tabs":_vm.tabs,"addon-apps-location":"Equipment Module","addon-apps-link":"/equipment/apps"}})
}
var staticRenderFns = []

export { render, staticRenderFns }